import Vue from 'vue';
import Router from 'vue-router';
import AOS from 'aos';

import Home from './../components/Home';
import About from './../components/About';
import Contatti from './../components/Contatti';
import Privacy from './../components/Privacy';
import Cookies from './../components/Cookies';
import Catalog from './../components/Catalog';
import CatalogResults from './../components/CatalogResults';
import Album from './../components/Album';
import Login from './../components/Login';
import Recover from './../components/Recover';
import ResetPassword from './../components/ResetPassword';
import User from './../components/User';
import UserEditProfile from './../components/UserEditProfile';
import Signup from './../components/Signup.vue';

import SignupSuccess from './../components/SignupSuccess';
import Report from './../components/Report';
import LetteraAttestazioneSiae from './../components/LetteraAttestazioneSiae';

let aosInterval;

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contatti',
    component: Contatti
  },
  {
    path: '/catalog',
    redirect: '/catalog/repertorio-tutti/artista-tutti/genere-tutti/album-tutti/brani-tutti/ordine-per-data/pagina-1'
  },
  {
    path: '/catalog/:album',
    name: 'Album',
    component: Album
  },
  {    
    path: '/catalog/:repertorio/:artist/:genre/:albums/:songs/:orderBy/:page',
    component: Catalog,
    children: [
      {
        name: 'Catalog',
        path: '',
        component: CatalogResults
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/recover',
    name: 'Recover',
    component: Recover
  },
  {
    path: '/reset_password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/user',
    name: 'User',
    component: User
  },
  {
    path: '/edit-profile',
    name: 'UserEditProfile',
    component: UserEditProfile
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/signup-success',
    name: 'SignupSuccess',
    component: SignupSuccess
  },
  {
    path: '/report',
    name: 'Report',
    component: Report
  },
  {
    path: '/cookies',
    name: 'Cookies',
    component: Cookies
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/lettera-attestazione-siae',
    name: 'Lettera Attestazione Siae',
    component: LetteraAttestazioneSiae
  }
];

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(from.name != 'Catalog' || to.name != 'Catalog') {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if(aosInterval) {
    clearInterval(aosInterval);
  }

  if(to.name != 'Catalog') {
    aosInterval = setInterval(() => AOS.init(), 200);
  }
  
  next();
});

export default router;


// WEBPACK FOOTER //
// ./src/vue/router/index.js